import { first } from 'lodash';

import { aTypeUpdateProcedure } from 'actions/shared.types';
import CONF from 'config/conf.singleton';
import H from 'constants/httpMethod.const';
import { AUTH_API } from 'middleware/api';
import fromActionTypeToArray from 'utils/converters/mw/fromActionTypeToArray.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';
import { isNotValidId } from 'utils/predicates/fields.util';

// DEPRECATED: use new action deleteAllAppointmentsV2 or deleteAllAppointmentsV3
export const deleteAllAppointmentsV1 = (salonId, procedures) => {
  const appointment = first(procedures)?.appointment;

  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `salon/${salonId}/repeating/appointment/${appointment?.id}/`,
      authenticated: true,
      types: fromActionTypeToArray(aTypeUpdateProcedure),
      params: { salonId, procedures },
      config: {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...(appointment ?? {}),
          client: { ...(appointment?.client ?? {}), salon_id: salonId },
          client_id: appointment?.client ? appointment?.client?.id : null,
          notes: appointment?.notes || 'deleted',
          procedures,
          origin: 'salon_created',
          status: 'deleted',
        }),
      },
    },
  };
};

export const deleteAllAppointmentsV3 = actionEndpointBe(
  'ibeSalonCoreUpdate',
  H.del,
  `salon/:salonId/repeating/appointment/:appointmentId/`,
  (options, extra) => ({
    ...options,
    inert: false,
    isMissingParams: isNotValidId(extra?.appointmentId),
    params: { appointmentId: extra?.appointmentId ?? 0 },
  }),
);
